import '../base';
import '../components/carousels/mobile-carousel';
